export default "__VITE_ASSET__fdfd85ef__"